import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

class HighLowSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorHigh = this.yAccessorHigh.bind(this);
    this.yAccessorLow = this.yAccessorLow.bind(this);
  }

  yAccessorHigh(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).hhv;
  }

  yAccessorLow(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).llv;
  }

  render() {
    const {
      className,
      strokeHigh,
      strokeLow,
      highlightOnHover,
      onDoubleClick,
      onContextMenu,
    } = this.props;

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        <LineSeries
          yAccessor={this.yAccessorHigh}
          stroke={strokeHigh}
          fill="none"
          highlightOnHover={highlightOnHover}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorLow}
          stroke={strokeLow}
          fill="none"
          highlightOnHover={highlightOnHover}
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

HighLowSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  strokeHigh: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  strokeLow: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  highlightOnHover: PropTypes.bool,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

HighLowSeries.defaultProps = {
  className: "react-stockcharts-highlow-series",
  strokeHigh: { color: "#4CAF50" },
  strokeLow: { color: "#F44336" },
  highlightOnHover: true,
};

export default HighLowSeries;
